import { useConfig } from "@dit/ui-configurations/configurations";
import { FC, PropsWithChildren, Suspense, useMemo } from "react";
import { GlobalConfigDefinition } from "../globalConfig";
import { initTheme } from "@app/initTheme";
import { ApplicationThemeProvider } from "./ApplicationThemeProvider";

export const ApplicationThemeLoader: FC<PropsWithChildren> = ({ children }) => {
    const config = useConfig<GlobalConfigDefinition, GlobalConfigDefinition>(_ => _);
    const tenantKey = config?.tenantKey;

    const themes = useMemo(() => initTheme(tenantKey), [tenantKey]);

    return (
        <Suspense fallback={null}>
            <ApplicationThemeProvider themesPromise={themes}>{children}</ApplicationThemeProvider>
        </Suspense>
    );
};
